import { getV1 } from '@/common/utils/ajax'
import { DEFAULT_PER } from '@/config'

const handleParams = (data) => {
    Object.keys(data).forEach((key) => {
        if (!data[key]) {
            delete data[key]
        }
    })
}

const getSurplusBuildings = (data) => {
    handleParams(data)
    return getV1('surplus_buildings', {
        per: DEFAULT_PER,
        ...data
    })
}

export default {
    getSurplusBuildings
}
